import React from "react"

/*共通ディスクレイマー（原則、全ての画面に提供）*/
export const CommonDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span>
        本サービスは、株式会社トレードワークスのシステムをベースに、株式会社ミンカブ・ジ・インフォノイド、株式会社東京証券取引所、株式会社大阪取引所、ICE
        Data
        Services（海外取引所含む）、S＆Pグローバル・マーケット・インテリジェンス、株式会社QUICK、株式会社DZHフィナンシャルリサーチの情報を配信（配信される情報は、以下「本件コンテンツ」）しております。株式会社トレードワークスをはじめ該当する情報提供各社（以下、「コンテンツ・プロバイダー」）の事前許可を得た場合を除き、如何なる形式であれ本件コンテンツの再配信は禁じられています。また本サービスにて提供するコンテンツの正確性、適切性、完全性、適時性又は利用可能性を保証することはなく、原因の如何を問わず又は本件コンテンツを利用した結果としての誤謬又は脱漏（過失等によるものも含みます。）につき責任を負いません。また、如何なる事由であれ、コンテンツ・プロバイダーが、本件コンテンツの利用に関連して発生した損害、費用、経費、弁護士費用又は損失（逸失利益又は機会費用を含みます。）につき責任を負うことはありません。本件コンテンツは、投資対象若しくは証券に言及したとしても、かかる投資対象又は証券の購入、売却又は保有を推奨するものではなく、投資対象又は証券の投資適合性について勧告したものでもなく、投資助言としてそれに依拠してはならないものとします。
      </span>
    </li>
    <li>
      <span>
        日経平均株価、日経株価指数300、日経ジャスダック平均株価に関する著作権ならびに「日経」および日経平均株価、日経株価指数300、日経ジャスダック平均株価、JPX日経インデックス400の表示に対する知的財産権その他一切の権利は、全て日本経済新聞社に帰属します。
      </span>
    </li>
    <li>
      <span>
        “HKEX Information Services Limited, its holding companies and/or any
        subsidiaries of such holding companies endeavour to ensure the accuracy
        and reliability of the Information provided but do not guarantee its
        accuracy or reliability and accept no liability (whether in tort or
        contract or otherwise) for any loss or damage arising from any
        inaccuracies or omissions”.
      </span>
      <div>
        （参考訳：香港取引所から提供された情報について、HKEXインフォメーションサービスリミテッド、その持株会社および/またはその子会社は、その正確性または信頼性を保証するものではなく、情報の不正確性または不作為に起因する損失または損害に対する責任（不法行為、契約またはその他）を一切負うものではありません。）
      </div>
    </li>
    <li>
      <span>S&Pデータ：Copyright 2020, S&P Global Market Intelligence</span>
    </li>
  </ul>
)

/*ワールドサマリ補足説明*/
export const WorldSummaryDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">
        各国及び各国取引所の配信データ（株価、株価指数）について：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国の配信データは、各国通貨建ての表示となります。
        </span>
        <span className="list-desc-row break">
          各国及びその各国取引所が発表している遅延時間は以下の通りとなります。
        </span>
        <span className="list-desc-row">
          10分遅延：インドネシア、シンガポール（株式）
        </span>
        <span className="list-desc-row">
          15分遅延：香港※、中国、ベトナム、タイ、マレーシア、フィリピン、シンガポール（指数）
        </span>
        <span className="list-desc-row">20分遅延：韓国、台湾</span>
        <span className="list-desc-row">
          ※個別銘柄株価情報については、リアルタイム配信
        </span>
        <span className="list-desc-row break">
          米国株式、イスラエルは、終値を表示しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">外国為替配信データについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          ICE Data Servicesよりデータ提供を受け、リアルタイム配信しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">
        各国国債・商品及び各国先物指数・政策金利について：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国国債：各国発表情報を取得し、コンテンツ・ベンダーでのデータ処理の上、更新しております。更新時間に配信。
        </span>
        <span className="list-desc-row break">
          商品及び各国先物指数：コンテンツ・ベンダー及び各国先物取引所が発表している遅延時間に基づき配信。
        </span>
        <span className="list-desc-row break">
          政策金利：各国発表情報を取得し、コンテンツ・ベンダーでのデータ処理の上、更新しております。更新時間に配信。
        </span>
      </span>
    </li>
  </ul>
)

/*外国株式サマリ補足説明*/
export const ForeignEquityDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">
        各国及び各国取引所の配信データ（株価、株価指数）について：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国の配信データは、各国通貨建ての表示となります。
        </span>
        <span className="list-desc-row break">
          各国及びその各国取引所が発表している遅延時間は以下の通りとなります。
        </span>
        <span className="list-desc-row">
          10分遅延：インドネシア、シンガポール（株式）
        </span>
        <span className="list-desc-row">
          15分遅延：香港※、中国、ベトナム、タイ、マレーシア、フィリピン、シンガポール（指数）
        </span>
        <span className="list-desc-row">20分遅延：韓国、台湾</span>
        <span className="list-desc-row">
          ※個別銘柄株価情報については、リアルタイム配信
        </span>
        <span className="list-desc-row break">
          米国株式、イスラエルは、終値を表示しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">外国為替配信データについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          ICE Data Servicesよりデータ提供を受け、リアルタイム配信しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">
        各国国債・商品及び各国先物指数・政策金利について：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国国債：各国発表情報を取得し、コンテンツ・ベンダーでのデータ処理の上、更新しております。更新時間に配信。
        </span>
        <span className="list-desc-row break">
          商品及び各国先物指数：コンテンツ・ベンダー及び各国先物取引所が発表している遅延時間に基づき配信。
        </span>
        <span className="list-desc-row break">
          政策金利：各国発表情報を取得し、コンテンツ・ベンダーでのデータ処理の上、更新しております。更新時間に配信。
        </span>
      </span>
    </li>
  </ul>
)

/*主要指数補足説明*/
export const MainIndexDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">各国指数の通貨及び表示小数点について：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国指数は、各国通貨建てにて表示しております。
        </span>
        <span className="list-desc-row break">
          小数点3位以下を四捨五入し、小数2桁の表示をしております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">遅延データについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国及びその各国取引所が発表している遅延時間は以下の通りとなります。
        </span>
        <span className="list-desc-row">
          10分遅延：インドネシア、シンガポール（株式）
        </span>
        <span className="list-desc-row">
          15分遅延：香港※、中国、ベトナム、タイ、マレーシア、フィリピン、シンガポール（指数）
        </span>
        <span className="list-desc-row">20分遅延：韓国、台湾</span>
        <span className="list-desc-row">
          ※個別銘柄株価情報については、リアルタイム配信
        </span>
        <span className="list-desc-row break">
          米国株式、イスラエルは、終値を表示しております。
        </span>
      </span>
    </li>
  </ul>
)

/*外国為替補足説明 */
export const FXDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">外国為替配信データについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          ICE Data Servicesよりデータ提供を受け、リアルタイム配信しております。
        </span>
        <span className="list-desc-row break">
          BID（買気配）を表示しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">対日本円レートについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          1現地通貨を日本円換算した数値を表示しております。（ただし、以下の通貨除く）
        </span>
        <span className="list-desc-row break">
          インドネシアルピア、ベトナムドンについては、100現地通貨を日本円に換算した数値を表示しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">対米国ドルについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          1米ドルを現地通貨換算した数値を表示しております。（ただし、以下の通貨除く）
        </span>
        <span className="list-desc-row break">
          ユーロ、豪ドル、ニュージーランドドル、については、1現地通貨を米ドルに換算した数値を表示しております。日本円は、100円を米ドル換算した数値を表示しております。
        </span>
      </span>
    </li>
  </ul>
)

/*商品補足説明 */
export const InstrumentDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">商品配信データについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          米ドル建てを表示しております。
        </span>
        <span className="list-desc-row break">
          BID（買気配）または現値を表示しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">遅延データについて：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          リアルタイム：金 現物、銀 現物
        </span>{" "}
        <span className="list-desc-row break">
          遅延データ：金 NY先物、銀 NY先物、プラチナ NY先物、パラジウム
          NY先物、WTI原油 先物
        </span>
      </span>
    </li>
  </ul>
)

/*銘柄詳細説明 */
export const SymbolDetailDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">国内株式：</span>
      <span className="list-title">業績予想について：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          国内株式の予想については、会社予想を表示しております。
        </span>
        <span className="list-desc-row break">
          外国株式の予想については、S&Pコンセンサス予想を表示しております。
        </span>
      </span>
    </li>
  </ul>
)

/*時系列補足説明 */
export const SymbolDataDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">
        時系列データ及びヒストリカルデータ、前日終値の株価調整について：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          国内株式については、コーポレートアクション情報に基づき、時系列データ等に対し、以下の株価調整を行っております。
        </span>
        <span className="list-desc-row">
          以下の資本異動について、権利落日のマーケット開始前までには株価チャート等を修正。
        </span>
        <table className="table table-board-order table-striped">
          <thead>
            <tr>
              <th className="small-contents">異動種別</th>
              <th className="medium-contents">修正の考え方</th>
              <th className="small-contents">計算式</th>
              <th className="large-contents">計算式例</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>株式分割</td>
              <td>
                x株をY株とする株式分割で株数が増えるため、分割比率で除する
              </td>
              <td>過去値＊X/Y</td>
              <td>
                1株（X）を5株（Y）に分割。前日終値100円
                <span className="ellipsis-text">100円＊1/5＝20円</span>
              </td>
            </tr>
            <tr>
              <td>株式併合</td>
              <td>x株をY株とする株式併合で株数が減るため、併合比率で乗する</td>
              <td>過去値＊X/Y</td>
              <td>
                5株（X）を1株（Y）に併合。前日終値100円
                <span className="ellipsis-text">100円＊5/1＝500円</span>
              </td>
            </tr>
            <tr>
              <td>株主割当（無償）</td>
              <td>
                x株につきY株の株式割当（無償交付）で株数が増えるため、割当による分割比率で除する
              </td>
              <td>過去値＊X/（X＋Y）</td>
              <td>
                1株（X）に1株（Y）を無償割当。前日終値100円
                <span className="ellipsis-text">
                  100円＊1/（1＋1）＝100＊1/2＝50円
                </span>
              </td>
            </tr>
            <tr>
              <td>株主割当（有償）</td>
              <td>
                X株につきY株の株主割当増資で、割当価格は1株あたりZ円で株数は増えるため、割当価格を考慮した分割比率で除する
              </td>
              <td>（（過去値＊X）＋（Y＊Z））/（X＋Y）</td>
              <td>
                1株（X）に1株（Y）を1株80円（Z）で有償割当。
                <span className="ellipsis-text">前日終値100円</span>
                <span className="ellipsis-text">
                  （（100円＊1）＋（1＊80円））/（1＋1）＝90円
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  ライツイッシュー
                  <span className="ellipsis-text">（新株予約権無償割当）</span>
                </div>
              </td>
              <td>
                <div>
                  X株につき新株予約権A割当、予約権1（B）に対する新株予約権につきY株の、割当価格1株あたりZ円買う権利を付与するもののため割当価格を考慮した分割比率で除する
                  <span className="ellipsis-text">
                    x株につき、Y株の割当率は、X:A＊Yとなる
                  </span>
                </div>
              </td>
              <td>（（過去値＊X）＋（A/X＊Y/B＊Z＊B/Y）/（X＋A/X＊Y/B）</td>
              <td>
                1株（X）0.5株（A）の新株予約権に対し、1（B）の新株予約権につき、株式0.5株（Y）を行使価額1株60円（Z）で割当。前日終値100円
                <span className="ellipsis-text">
                  （（100円＊1）＋（0.5＊60円））/（1＋0.25）＝104円
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </span>
    </li>
    <li>
      <span className="list-desc">
        <span className="list-desc-row break">
          外国株式については、修正後株価※に基づき修正係数を算出の上、時系列データ等に対し、以下の株価調整を行っております。
        </span>
        <span className="list-desc-row">
          前日終値/修正後株価より、株価修正係数を算出し、過去の株価（日足）を修正しております。
        </span>
        <span className="list-desc-row">
          ※修正後株価は、株式会社ミンカブ・ジ・インフォノイドより提供を受けております。
        </span>
      </span>
    </li>
  </ul>
)

/*銘柄検索補足説明*/
export const SymbolSearchDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">
        各国及び各国取引所の配信データについて：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国の配信データは、各国通貨建ての表示となります。
        </span>
        <span className="list-desc-row break">
          各国及びその各国取引所が発表している遅延時間は以下の通りとなります。
        </span>
        <span className="list-desc-row">
          10分遅延：インドネシア、シンガポール（株式）
        </span>
        <span className="list-desc-row">
          15分遅延：香港※、中国、ベトナム、タイ、マレーシア、フィリピン、シンガポール（指数）
        </span>
        <span className="list-desc-row">20分遅延：韓国、台湾</span>
        <span className="list-desc-row">
          ※個別銘柄株価情報については、リアルタイム配信
        </span>
        <span className="list-desc-row break">
          米国株式、イスラエルは、終値を表示しております。
        </span>
      </span>
    </li>
  </ul>
)

/*登録銘柄（4本値他）及び銘柄リスト補足説明*/
export const RegisterSymbolDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">
        各国及び各国取引所の配信データについて：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国の配信データは、各国通貨建ての表示となります。
        </span>
        <span className="list-desc-row break">
          各国及びその各国取引所が発表している遅延時間は以下の通りとなります。
        </span>
        <span className="list-desc-row">
          10分遅延：インドネシア、シンガポール（株式）
        </span>
        <span className="list-desc-row">
          15分遅延：香港※、中国、ベトナム、タイ、マレーシア、フィリピン、シンガポール（指数）
        </span>
        <span className="list-desc-row">20分遅延：韓国、台湾</span>
        <span className="list-desc-row">
          ※個別銘柄株価情報については、リアルタイム配信
        </span>
        <span className="list-desc-row break">
          米国株式、イスラエルは、終値を表示しております。
        </span>
      </span>
    </li>
  </ul>
)

/*登録銘柄（ポートフォリオ）補足説明*/
export const PortfolioDisclaimerText = (
  <ul className="data-disclaimer-list">
    <li>
      <span className="list-title">
        各国及び各国取引所の配信データについて：
      </span>
      <span className="list-desc">
        <span className="list-desc-row break">
          各国の配信データは、各国通貨建ての表示となります。
        </span>
        <span className="list-desc-row break">
          各国及びその各国取引所が発表している遅延時間は以下の通りとなります。
        </span>
        <span className="list-desc-row">
          10分遅延：インドネシア、シンガポール（株式）
        </span>
        <span className="list-desc-row">
          15分遅延：香港※、中国、ベトナム、タイ、マレーシア、フィリピン、シンガポール（指数）
        </span>
        <span className="list-desc-row">20分遅延：韓国、台湾</span>
        <span className="list-desc-row">
          ※個別銘柄株価情報については、リアルタイム配信
        </span>
        <span className="list-desc-row break">
          米国株式、イスラエルは、終値を表示しております。
        </span>
      </span>
    </li>
    <li>
      <span className="list-title">為替情報について：</span>
      <span className="list-desc">
        <span className="list-desc-row break">
          対日本円レートは、1現地通貨を日本円換算した数値を表示しております。ただし、インドネシアルビア、ベトナムドンはそれぞれ100ルピア、100ドンを日本円に換算した数値を表示しております。
        </span>
      </span>
    </li>
  </ul>
)
